import { render, staticRenderFns } from "./VActivityForm.vue?vue&type=template&id=de446bf6&"
import script from "./VActivityForm.vue?vue&type=script&lang=js&"
export * from "./VActivityForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports